export default function newSyncableSectionBodyChangeDirective() {
  return {
    template: require('./new-syncable-section-body-change.html'),
    restrict: 'E',
    controller: 'NewSyncableSectionBodyChangeController',
    controllerAs: 'newSyncableSectionBodyChangeVM',
    bindToController: true,
    replace: true,
    scope: {
      change: '=',
      isNew: '=',
      ssTooltipAppendToSelector: '@',
      handleApproveChangeClick: '&',
      handleDenyChangeClick: '&',
      isBatch: '=',
    },
  };
}
